<template>
  <transition name="slimeopacity">
    <div class="windowsinfo" v-if="loading">
      <div class="podblock">
        <div class="logo-container">
          <svg
            width="17"
            height="19"
            viewBox="0 0 17 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8695 15.9484L12.8726 19H4.12735L1.13049 15.9699V4.27015H0V0H7.41217V4.27015H6.29235V14.126L6.90025 14.7191H10.1211L10.7077 14.126V4.27015H9.58783V0H17V4.27015H15.8695V15.9484Z"
              :fill="isDarkTheme ? '#f0f0f0' : '#1a1a1a'"
            />
          </svg>
          <div class="circle-spinner"></div>
        </div>

        <p>Загружаем...</p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { loading } from '@/controlles/general'
import { useTheme } from '@/composables/useTheme'

const { isDarkTheme } = useTheme()
</script>

<style scoped>
.windowsinfo {
  width: 100%;
  height: 100vh;
  z-index: 999999999999;
  background: var(--overlay-light);
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  align-items: center;
  justify-items: center;
  backdrop-filter: blur(5px);
}

.podblock {
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 20px;
}

.podblock p {
  font-weight: 300;
  font-size: 16px;
  color: var(--text-primary);
  letter-spacing: 0.3px;
  margin: 0;
}

.logo-container {
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container svg {
  width: auto;
  height: 35px;
  position: relative;
  z-index: 2;
}

.circle-spinner {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: var(--text-primary);
  border-right-color: var(--text-primary);
  border-bottom-color: var(--border-light);
  border-left-color: var(--border-light);
  animation: spin 1.2s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
  box-shadow: 0 0 15px var(--shadow-color);
}

.circle-spinner::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: var(--text-secondary);
  border-left-color: var(--border-medium);
  animation: spin-reverse 2s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin-reverse {
  to {
    transform: rotate(-360deg);
  }
}

.slimeopacity-enter-active {
  transition: all 200ms ease;
}
.slimeopacity-leave-active {
  transition: all 200ms;
}
.slimeopacity-enter,
.slimeopacity-leave-to {
  opacity: 0;
}

@supports (backdrop-filter: blur(5px)) {
  .windowsinfo {
    background: var(--overlay-light);
    backdrop-filter: blur(10px);
  }
}
</style>